export default __webpack_public_path__ + "static/media/ic_boo_40.b47f989f.svg";